export default __webpack_public_path__ + "static/chang-cb5cbddef55cba2722c38670075eafff.jpeg";